/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Window_Resize_BrInputs */

const en_window_resize_br = /** @type {(inputs: Window_Resize_BrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resize from bottom-right`)
};

const ar_window_resize_br = /** @type {(inputs: Window_Resize_BrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تغيير الحجم من الزاوية السفلية اليمنى`)
};

const bn_window_resize_br = /** @type {(inputs: Window_Resize_BrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নিচ-ডান থেকে রিসাইজ করুন`)
};

const de_window_resize_br = /** @type {(inputs: Window_Resize_BrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Größe von unten rechts ändern`)
};

const es_window_resize_br = /** @type {(inputs: Window_Resize_BrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar tamaño desde abajo a la derecha`)
};

const fr_window_resize_br = /** @type {(inputs: Window_Resize_BrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redimensionner en bas à droite`)
};

const pt_window_resize_br = /** @type {(inputs: Window_Resize_BrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redimensionar do canto inferior direito`)
};

const zh_window_resize_br = /** @type {(inputs: Window_Resize_BrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从右下角调整大小`)
};

const tr_window_resize_br = /** @type {(inputs: Window_Resize_BrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sağ alttan yeniden boyutlandır`)
};

const ru_window_resize_br = /** @type {(inputs: Window_Resize_BrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменение размера снизу справа`)
};

const pl_window_resize_br = /** @type {(inputs: Window_Resize_BrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmień rozmiar od prawego dolnego rogu`)
};

/**
* | output |
* | --- |
* | "Resize from bottom-right" |
*
* @param {Window_Resize_BrInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const window_resize_br = /** @type {((inputs?: Window_Resize_BrInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Window_Resize_BrInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_window_resize_br(inputs)
	if (locale === "bn") return bn_window_resize_br(inputs)
	if (locale === "de") return de_window_resize_br(inputs)
	if (locale === "es") return es_window_resize_br(inputs)
	if (locale === "fr") return fr_window_resize_br(inputs)
	if (locale === "pt") return pt_window_resize_br(inputs)
	if (locale === "zh") return zh_window_resize_br(inputs)
	if (locale === "tr") return tr_window_resize_br(inputs)
	if (locale === "ru") return ru_window_resize_br(inputs)
	if (locale === "pl") return pl_window_resize_br(inputs)
	return en_window_resize_br(inputs)
});